import React from "react";
import AboutHero from "../components/AboutHero";

import OptionHero from "../components/OptionHero";

export default function About() {
  return (
    <>
      <AboutHero />
      <OptionHero />
    </>
  );
}
